import { registerTrigger, triggerNotify, subscribeUniqueNamedNotify, triggerUniqueNamedNotify } from "../../@helpers/js/observer.js";
import { processEvent } from "../../@helpers/js/queue-processing.js";

class CollectiveChoice {
	constructor(element) {
		this._element = element;

		this.init();
	}

	init() {
		this._choiceContainer = this._element.querySelector('[data-collective-choice]');
		this._blockedMessage = this._element.querySelector('[data-collective-blocked]');
		if (this._choiceContainer) {
			this._collectiveWrapper = this._element.querySelector('[data-collective-wrapper]');
			this._inputs = [...this._choiceContainer.querySelectorAll('input[type=radio]')];
			if (this._inputs && this._inputs.length > 0 && this._collectiveWrapper) {

				const whileChoosingAid = this._element.closest('[data-module="ChoosingAid"]');
				const changeProcessor = processEvent(async (input) => {
					if (input.checked) {
						const yepnope = input.value;
						if (whileChoosingAid) {
							await triggerUniqueNamedNotify(`choosingaid_collectivechoice_${yepnope}_selected`, {name: 'pakketkiezer'});
						} else {
							await triggerNotify(`collectivechoice_${yepnope}_selected`);
						}
						if (yepnope == 'no') {
							this._collectiveWrapper.classList.add('t-hidden');
						} else {
							this._collectiveWrapper.classList.remove('t-hidden');
						}
					}
				});
				this._inputs.forEach(input => {
					if (whileChoosingAid) {
						registerTrigger(`choosingaid_collectivechoice_${input.value}_selected`);
					} else {
						registerTrigger(`collectivechoice_${input.value}_selected`);
					}
					input.addEventListener('change', async () => {
						changeProcessor.push(input);
						if (this._blockedMessage) {
							this._blockedMessage.classList.add('t-hidden');
							this._blockedMessage = false;
						}
					});
				});
			}
			subscribeUniqueNamedNotify('shoppingcart_checkcollectivity_blocked', {
				fn: () => {
					if (!!this._blockedMessage) {
						this._element.scrollIntoView();
					}
					return !!this._blockedMessage;
				}, name: 'collectivity_blocked'
			});
		}
	}
}

export default CollectiveChoice;